import { render, staticRenderFns } from "./GenericControlPolicy.vue?vue&type=template&id=64d29221&scoped=true&"
import script from "./GenericControlPolicy.vue?vue&type=script&lang=js&"
export * from "./GenericControlPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d29221",
  null
  
)

export default component.exports